export const rgbToHslShaderHelpers = `
${/* RGB to HSL conversion */ ""}
vec3 rgb2hsl(vec3 color) {
  float maxColor = max(max(color.r, color.g), color.b);
  float minColor = min(min(color.r, color.g), color.b);
  float delta = maxColor - minColor;

  float h = 0.0;
  float s = 0.0;
  float l = (maxColor + minColor) / 2.0;

  if (delta > 0.0) {
    s = l < 0.5 ? delta / (maxColor + minColor) : delta / (2.0 - maxColor - minColor);

    if (maxColor == color.r) {
      h = (color.g - color.b) / delta + (color.g < color.b ? 6.0 : 0.0);
    } else if (maxColor == color.g) {
      h = (color.b - color.r) / delta + 2.0;
    } else {
      h = (color.r - color.g) / delta + 4.0;
    }
    h /= 6.0;
  }

  return vec3(h, s, l);
}

${/* HSL to RGB conversion */ ""}
float hue2rgb(float p, float q, float t) {
  if (t < 0.0) t += 1.0;
  if (t > 1.0) t -= 1.0;
  if (t < 1.0/6.0) return p + (q - p) * 6.0 * t;
  if (t < 1.0/2.0) return q;
  if (t < 2.0/3.0) return p + (q - p) * (2.0/3.0 - t) * 6.0;
  return p;
}

vec3 hsl2rgb(vec3 hsl) {
  vec3 rgb;

  if (hsl.y == 0.0) {
    rgb = vec3(hsl.z); // Achromatic
  } else {
    float q = hsl.z < 0.5 ? hsl.z * (1.0 + hsl.y) : hsl.z + hsl.y - hsl.z * hsl.y;
    float p = 2.0 * hsl.z - q;
    
    rgb.r = hue2rgb(p, q, hsl.x + 1.0/3.0);
    rgb.g = hue2rgb(p, q, hsl.x);
    rgb.b = hue2rgb(p, q, hsl.x - 1.0/3.0);
  }

  return rgb;
}
`;
